(function() {
  'use strict';

  angular
    .module('ppt.pptImageCtrl', [])
    .controller('PptImageCtrl', PptImageCtrl);

  PptImageCtrl.$inject = ['$scope', 'Navigation', '$timeout'];

  function PptImageCtrl($scope, Navigation, $timeout) {
    $scope.pptImageInfo = $scope.currentSlide;

    // Wait 10 seconds. If it's not preloaded then just show the slide.
    var preloadTimeoutPromise = $timeout(function() {
      $scope.showSlide();
    }, 10000);

    $scope.showSlide = function() {
      Navigation.state = Navigation.states.ready;
      Navigation.showNavControls = true;
      if (preloadTimeoutPromise) {
        $timeout.cancel(preloadTimeoutPromise);
        preloadTimeoutPromise = null;
      }
    };

    $scope.$on('$destroy', function() {
      if (preloadTimeoutPromise) {
        $timeout.cancel(preloadTimeoutPromise);
        preloadTimeoutPromise = null;
      }
    });
  }
})();
